import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import api from '../../api/api';
import uri from '../../variables/uri';
import history from '../../history';
import editImg from '../../images/edit.png';
import SelectedTopicModal from '../modals/SelectedTopicModal';
import addImg from '../../images/add.png';
import util from '../../functions/Utilities';
import SubHeader from './SubHeader';

class Query extends React.Component {
    state = {
        subjectList: [],
        topicList: [],
        conditionList: [],
        permissionList: [],
        permissionArr: [],
        permissionSelection: [],
        permissionId: '',
        selected: '',
        hilight: '',
        hide: true,
        isOpen: false,
        selectedTopic: {},
        action: '',
        selectedSubject: '',
        typeId: ''
    }

    componentDidMount() {
        if (!this.props.isAuthen) {
            history.push(`/home/${this.props.match.params.userId}`)
        } else {
            let uniqSubject = _.uniqBy(this.props.topicList, 'SubjectTitle');
            let filteredTopic = _.sortBy(this.props.topicList, 'TopicID');
            if (this.props.doa.levelOne !== '' && this.props.doa.levelOne !== 'Please select Level 1') {
                uniqSubject = uniqSubject.filter(item => item.SubjectTitle === this.props.doa.levelOne);
            }
            if (this.props.doa.levelTwo !== '' && this.props.doa.levelTwo !== 'Please select Level 2') {
                const found = this.props.topicList.find(item => item.TopicTitle === this.props.doa.levelTwo);
                if (found) {
                    filteredTopic = filteredTopic.filter(item => (item.TopicNo.includes(found.TopicNo + '.') || item.TopicNo === found.TopicNo));
                }
            }
            this.setState({ subjectList: uniqSubject, topicList: filteredTopic, conditionList: this.props.conditionList });
            if (uniqSubject.length === 1) {
                this.onSubjectSelected(uniqSubject[0]);
                this.setState({ selected: uniqSubject[0].SubjectTitle });
            }
            if (this.props.type === 'อำนาจทั่วไป / General') this.setState({ typeId: 1 })
            else if (this.props.type === 'อำนาจเฉพาะ / Speciality') this.setState({ typeId: 2 })
            else if (this.props.type === 'พิเศษ / Extra') this.setState({ typeId: 3 })
        }
    }

    onBackPressed() {
        history.goBack();
    }

    onSubjectSelected = async (subject) => {
        if (this.state.permissionId !== subject.PermissionGroupID) {
            const response = await api.get(`${uri.GET_PERMISSION_LIST}?PermissionGroupID=${subject.PermissionGroupID}`);
            const permissionArr = [];
            response.data.forEach(element => {
                permissionArr.push(element.PermissionName !== null ? element.PermissionName : element.PermissionValue);
            });
            let permissionSelection = permissionArr;
            permissionSelection.push('Please select');
            permissionSelection = permissionSelection.reverse();
            this.setState({ selected: subject.SubjectTitle, permissionId: subject.PermissionGroupID, permissionList: _.sortBy(response.data, 'PermissionSequence').reverse(), permissionArr, permissionSelection });
        } else if (this.state.selected === subject.SubjectTitle) {
            this.setState({ selected: '' });
        } else {
            this.setState({ selected: subject.SubjectTitle });
        }
    }

    assignText(obj, type) {
        const { ApprovalText, SignText, ReportText } = obj;

        switch (type) {
            case 'ASR':
                return 'อ/ล/ท'
            case 'AS':
                return 'อ/ล'
            case 'SR':
                return 'ล/ท'
            case 'AR':
                return 'อ/ท'
            case 'A':
                if (ApprovalText !== null) return ApprovalText
                return 'อ'
            case 'S':
                if (SignText !== null) return SignText
                return 'ล'
            case 'R':
                if (ReportText !== null) return ReportText
                return 'ท'
            default:
                return;
        }
        // if (Approval === Sign === Report && Approval !== 0 && Sign !== 0 && Report !== 0) return 'อลท';
        // else if (Approval === Sign && Approval !== 0 && Sign !== 0) return 'อล';
        // else if (Approval === Report && Approval !== 0 && Report !== 0) return 'อท';
        // else if (Approval !== 0 && ApprovalText !== null) return ApprovalText;
        // else if (Sign !== 0 && SignText !== null) return SignText;
        // else if (Report !== 0 && ReportText !== null) return ReportText;
        // else if (Approval !== 0) return 'อ';
        // else if (Sign !== 0) return 'ล';
        // else if (Report !== 0) return 'ท';
        // else return '';
    }

    hilight(hilight) {
        if (this.state.hilight === hilight) {
            this.setState({ hilight: '' });
        } else {
            this.setState({ hilight });
        }
    }

    header() {
        return (
            <div style={{ height: '30px', border: '1px solid #ddd' }} className="flex-h flex-between bg-grey">
                <div className="flex-h flex-center">
                    <h4 className="ml-8 text-bold">อำนาจดำเนินการ</h4>
                </div>
                {<div className="flex-h">
                    {this.state.permissionList.map(permission => {
                        return (
                            <div key={permission.PermissionID} className="pl-8 pr-8 flex-h flex-center" style={{ width: '30px', height: '30px', borderLeft: '1px solid #ddd' }}>
                                <h4 className="text-bold" style={{ lineHeight: '1', textAlign: 'center', transform: 'rotate(270deg)' }}>{permission.PermissionName !== null ? permission.PermissionName : permission.PermissionValue}</h4>
                            </div>
                        );
                    })}
                    <div className="pl-8 pr-8 flex-h flex-center" style={{ width: '300px', height: '30px', borderLeft: '1px solid #ddd' }}>
                        <h4 className="ml-8 text-bold">Remark</h4>
                    </div>
                </div>
                }
            </div>
        );
    }

    onSelectedModalClose = () => {
        this.setState({ isOpen: false, action: '', selectedSubject: '' });
    }

    onAddTopic = (subject) => {
        this.onSubjectSelected(subject);
        this.setState({ isOpen: true, selectedTopic: undefined, action: 'add', selectedSubject: subject });
    }

    onEditTopic = (subject, topic) => {
        this.setState({ isOpen: true, selectedTopic: topic, action: 'edit', selectedSubject: subject });
    }

    assignFunc = (obj, type, i) => {
        return (
            <div key={i} className="flex-h flex-center" style={{ width: '30px', borderLeft: '1px solid #ddd' }}>
                <h5>{this.assignText(obj, type)}</h5>
            </div>
        )
    }

    render() {
        return (
            <div className="flex-v home">
                <div className="flex-v flex-1">
                    <SubHeader text={`${this.props.book.BookName} (${this.props.type})`} />
                    <div className="ml-8 mr-8">
                        {this.state.subjectList.length === 0 ?
                            <div className="card not-found">
                                Not Found
                        </div> :
                            this.state.subjectList.map((subject, i) => {
                                return (
                                    <div key={i} className="card pointer mt-8" style={{ overflow: 'scroll' }}>
                                        <div className="pl-8 pr-8" style={{ minWidth: '850px' }}>
                                            <div onClick={() => this.onSubjectSelected(subject)} className="flex-h flex-between">
                                                <h3 className="ml-16 pt-8 pb-8">{subject.SubjectTitle}</h3>
                                                {this.props.auth.role.Insert &&
                                                    <img onClick={(e) => { e.stopPropagation(); this.onAddTopic(subject) }} style={{ height: '25px' }} src={addImg} alt="" />}
                                            </div>
                                            {this.state.selected === subject.SubjectTitle &&
                                                <div>{this.header()}</div>
                                            }
                                            {this.state.selected === subject.SubjectTitle && this.state.topicList.map((topic, i) => {
                                                if (subject.SubjectTitle === topic.SubjectTitle)
                                                    return (
                                                        <div key={topic.TopicID} className={!topic.TopicNo.includes('.') && "mt-24 bt"}>
                                                            {(((this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle}`) || (this.state.hilight.includes(`${topic.TopicNo} ) ${topic.TopicTitle}`))) && i !== 0) &&
                                                                <div>{this.header()}</div>
                                                            }
                                                            <div onClick={() => this.hilight(`${topic.TopicNo} ) ${topic.TopicTitle}`)} style={{ borderBottom: '1px solid #ddd', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', alignItems: 'inherit' }} className={`flex-h flex-between ${this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle}` && 'bg-hilight'}`}>
                                                                <div className="flex-h flex-center">
                                                                    {(this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle}` && this.props.auth.role.Update) && <img onClick={() => this.onEditTopic(subject, topic)} className="ml-8 button-edit" src={editImg} alt="" />}
                                                                    <h5 dangerouslySetInnerHTML={{ __html: `${topic.TopicNo} ) ${topic.TopicTitle}` }} style={{ alignSelf: 'center', margin: '4px 8px' }}></h5>
                                                                </div>
                                                                {this.state.selected === subject.SubjectTitle &&
                                                                    <div className="flex-h">
                                                                        {topic.Remark != null ?
                                                                            <div className="flex-h flex-center" style={{ width: `${30 * this.state.permissionList.length}px`, borderLeft: '1px solid #ddd' }}>
                                                                                <h5>{topic.Remark}</h5>
                                                                            </div>
                                                                            :
                                                                            this.state.permissionList.map((permission, i) => {
                                                                                if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Sign) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'ASR', i)
                                                                                else if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Sign) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'AS', i)
                                                                                else if (Number(topic.Sign) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'SR', i)
                                                                                else if (Number(topic.Approval) === Number(permission.PermissionSequence) && Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'AR', i)
                                                                                else if (Number(topic.Approval) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'A', i)
                                                                                else if (Number(topic.Sign) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'S', i)
                                                                                else if (Number(topic.Report) === Number(permission.PermissionSequence))
                                                                                    return this.assignFunc(topic, 'R', i)
                                                                                else
                                                                                    return (
                                                                                        <div key={i} className="pl-8 pr-8" style={{ width: '30px', borderLeft: '1px solid #ddd' }}>
                                                                                            &nbsp;
                                                                                        </div>
                                                                                    );
                                                                            })}
                                                                        <div className="pl-8 pr-8  flex-h" style={{ width: '300px', borderLeft: '1px solid #ddd', alignItems: 'center' }}>
                                                                            <h5>{topic.Comments}</h5>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            {this.state.conditionList.map((condition, i) => {
                                                                if (topic.SubjectTitle === condition.SubjectTitle && topic.TopicNo === condition.TopicNo && this.state.typeId === condition.SubjectTypeID)
                                                                    return (
                                                                        <div>
                                                                            {/* {this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle} ${condition.ConditionTitle} ${i}` &&
                                                                                <div>{this.header()}</div>
                                                                            } */}
                                                                            <div onClick={() => this.hilight(`${topic.TopicNo} ) ${topic.TopicTitle} ${condition.ConditionTitle} ${i}`)} className={`flex-h flex-between ${this.state.hilight === `${topic.TopicNo} ) ${topic.TopicTitle} ${condition.ConditionTitle} ${i}` && 'bg-hilight'}`} style={{ borderBottom: '1px solid #ddd', borderLeft: '1px solid #ddd', borderRight: '1px solid #ddd', alignItems: 'inherit' }} key={condition.ConditionDetailID}>
                                                                                <h5 className="ml-16" style={{ alignSelf: 'center' }}>{condition.ConditionTitle}</h5>
                                                                                <div style={{ height: '30px' }} className="flex-h">
                                                                                    {condition.Remark != null ?
                                                                                        <div className="flex-h flex-center" style={{ width: `${30 * this.state.permissionList.length}px`, borderLeft: '1px solid #ddd' }}>
                                                                                            <h5>{condition.Remark}</h5>
                                                                                        </div>
                                                                                        :
                                                                                        this.state.permissionList.map((permission, i) => {
                                                                                            if (Number(condition.Approval) === Number(permission.PermissionSequence) && Number(condition.Sign) === Number(permission.PermissionSequence) && Number(condition.Report) === Number(permission.PermissionSequence))
                                                                                                return this.assignFunc(condition, 'ASR', i)
                                                                                            else if (Number(condition.Approval) === Number(permission.PermissionSequence) && Number(condition.Sign) === Number(permission.PermissionSequence))
                                                                                                return this.assignFunc(condition, 'AS', i)
                                                                                            else if (Number(condition.Sign) === Number(permission.PermissionSequence) && Number(condition.Report) === Number(permission.PermissionSequence))
                                                                                                return this.assignFunc(condition, 'SR', i)
                                                                                            else if (Number(condition.Approval) === Number(permission.PermissionSequence) && Number(condition.Report) === Number(permission.PermissionSequence))
                                                                                                return this.assignFunc(condition, 'AR', i)
                                                                                            else if (Number(condition.Approval) === Number(permission.PermissionSequence))
                                                                                                return this.assignFunc(condition, 'A', i)
                                                                                            else if (Number(condition.Sign) === Number(permission.PermissionSequence))
                                                                                                return this.assignFunc(condition, 'S', i)
                                                                                            else if (Number(condition.Report) === Number(permission.PermissionSequence))
                                                                                                return this.assignFunc(condition, 'R', i)
                                                                                            else
                                                                                                return (
                                                                                                    <div key={i} className="pl-8 pr-8" style={{ width: '30px', borderLeft: '1px solid #ddd' }}>

                                                                                                    </div>
                                                                                                );
                                                                                        })}
                                                                                    <div className="pl-8 pr-8 flex-h" style={{ width: '300px', borderLeft: '1px solid #ddd', alignItems: 'center' }}>
                                                                                        <h5>{condition.Comments}</h5>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    );
                                                            })}
                                                        </div>
                                                    );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
                <div className="p-8">
                    <button onClick={() => this.onBackPressed()} className="button is-info is-fullwidth mt-8 center">Back</button>
                </div>
                {this.state.isOpen && <SelectedTopicModal action={this.state.action} isOpen={this.state.isOpen} initial={util.onInitial(this.state.selectedTopic, this.state.conditionList)} onClose={this.onSelectedModalClose} permissionArr={this.state.permissionSelection} selectedSubject={this.state.selectedSubject} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthen: state.auth.isAuthen,
        topicList: state.doa.queryTopicList.filter(item => item.SubjectTypeTitle === state.doa.type),
        conditionList: state.doa.queryConditionList,
        type: state.doa.type,
        doa: state.doa.doa,
        book: state.doa.queryBook,
        auth: state.auth
    }
}
export default connect(mapStateToProps)(Query);